VjsAdmin.Group = (function () {
    const me = {};

    me.$group_users_table = $('#group-users-table');

    me.platform_id = me.$group_users_table.attr('data-platform-id');
    me.district_joint_guid = me.$group_users_table.attr('data-district-joint-guid');
    me.license_id = me.$group_users_table.attr('data-license-id');
    me.group_id = me.$group_users_table.attr('data-group-id');

    me.init = function () {
        me.initTable();
    };

    me.groupUsersTableQueryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
        myParams.active = this.search_active;
        return myParams;
    };

    me.initTable = function () {
        me.$group_users_table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#group-users-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                let active = '';
                switch (this.search_active) {
                    case '':
                    case 'all':
                        active = ' ';
                        break;
                    case 1:
                    case '1':
                        active = '<em>active</em> ';
                        break;
                    case 0:
                    case '0':
                        active = '<em>inactive</em> ';
                        break;
                    default:
                        break;
                }

                return `No ${active}<strong>users</strong> ${
                    typeof searchTerm !== 'undefined' && searchTerm !== '' ? ` matching search term <strong>\`${SafeDOM.escapeHtml(searchTerm)}\`</strong>` : ''
                } in this group.`;
            },
            showColumns: true,
            queryParams: me.groupUsersTableQueryParams,
            buttonsAlign: 'right',
            idField: 'user_id',
            sortName: 'user_id',
            search_active: 1,
            url: Slim.Router.pathFor('platforms.districts.licenses.groups.view.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
                license_id: me.license_id,
                group_id: me.group_id,
            }),
            columns: [
                {
                    title: 'Username',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Unique ID',
                    field: 'unique_identifier',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Role',
                    field: 'role',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Grade',
                    field: 'grade',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    title: 'Grad Year',
                    field: 'graduation_year',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
                    field: 'date_last_activity',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: 'Has Logged In',
                    field: 'has_logged_in',
                    align: 'venter',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.has_logged_in === 0) {
                        row.has_logged_in = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.has_logged_in = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    row.time_spent = VjsAdmin.secondsToHoursMinutes(row.time_spent);

                    const userUrl = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                        platform_id: me.platform_id,
                        district_joint_guid: me.district_joint_guid,
                        license_id: row.license_id,
                        user_id: row.user_id,
                    });
                    row.username = `<a href="${userUrl}">${row.username}</a>`;
                    row.first_name = `<a href="${userUrl}">${row.first_name}</a>`;
                    row.last_name = `<a href="${userUrl}">${row.last_name}</a>`;
                });
                return formattedResult;
            },

            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                const thisTable = this;

                $('#search-active').off();
                $('#search-active').on('change', () => {
                    if ($('#search-active option:selected').val() !== '') {
                        thisTable.search_active = $('#search-active option:selected').val();
                    } else {
                        thisTable.search_active = null;
                    }
                    thisTable.updateUrl();
                    $('#group-users-table').bootstrapTable('refresh');
                });

                if (typeof this.default_search_active === 'undefined') {
                    this.default_search_active = this.search_active;
                }
                this.search_active = $.urlParam('search_active') ? $.urlParam('search_active') : this.default_search_active;

                $(`#search-active option[value=${this.search_active}]`).attr('selected', true);
            },
            updateUrl() {
                const queryParams = {};
                if (+this.search_active !== +this.default_search_active) {
                    queryParams.search_active = this.search_active;
                }
                VjsTable.tableDefaults().updateUrl.call(this, queryParams);
            },
        });
    };

    return {
        init: me.init,
    };
}());
